import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTravelShootCreditBenefitsModal from './LandingPageLoyaltyTravelShootCreditBenefitsModal'

const image: App.Image = {
  id: 'r1z816jjifeqb5hwk50o',
  title: 'Pro photos on your trip',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props

  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTravelShootCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [showModal, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading="Pro photos on your trip"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Make the memories last. Use your Travelshoot voucher to book a professional{' '}
      photo session at your destination—perfect for couples, families, or solo travellers.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTravelShootCredit
